import { useIntl } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { EnhancedBanner } from "@/libraries/design/components/enhanced-banner/src/enhanced-banner";
import { useLocalizedHref } from "@/libraries/web-framework/index.ts";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const HomePageBannerAlert = () => {
    const intl = useIntl();

    const rovoLink = useLocalizedHref("/software/rovo");

    if (checkFeatureFlagGate(featureFlags.gwp9000NewRovoVideoHero)) {
        return (
            <UFOSegment name="homepage-banner-for-rovo-video-hero">
                <EnhancedBanner
                    uniqueIdentifier="homepage-banner-for-rovo-video-hero"
                    heading={intl.formatMessage({
                        id: "HomePage.banner-alert.rovo-video-hero.heading",
                        defaultMessage: "AI that knows your business"
                    })}
                    subheading={intl.formatMessage({
                        id: "HomePage.banner-alert.rovo-video-hero.subheading",
                        defaultMessage:
                            "Connect people, knowledge, and work to move faster together"
                    })}
                    subheadingMobile={intl.formatMessage({
                        id: "HomePage.banner-alert.rovo-video-hero.subheading",
                        defaultMessage: "Move faster together"
                    })}
                    ctaLinkHref={rovoLink}
                    ctaLinkText="Learn more"
                    productKey="rovo"
                    logoSrc="https://dam-cdn.atl.orangelogic.com/AssetLink/e88368535l6b5i8f4d4bllf0qd8883l5.png"
                    logoAlt="Rovo"
                    backgroundImageDesktop="https://dam-cdn.atl.orangelogic.com/AssetLink/74e8ik3281t1pfj7r1et1bqp0w785p02.webp"
                    backgroundImageTablet="https://dam-cdn.atl.orangelogic.com/AssetLink/6527616x38f1y570p50uh605exsh156t.webp"
                    backgroundImageMobile="https://dam-cdn.atl.orangelogic.com/AssetLink/16i008ah8tc23qhr6v355hkm34l0erdo.webp"
                    backgroundColor="black"
                />
            </UFOSegment>
        );
    }
};
